"use strict";
// Exoskeleton JS interface
// Copyright 2015-2024 Interitsement ApS
// REMOVED: This refers to exports which tsc does not emit: Object.defineProperty(exports, "__esModule", { value: true });
window.exo = {
    listeners: []
};
window.exo.broadcast = function (name, args) {
    var listeners = window.exo.listeners;
    for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
        var listener = listeners_1[_i];
        if (listener != null) {
            listener(name, args);
        }
    }
};
window.exo.addBroadcastListener = function (callback) {
    window.exo.listeners.push(callback);
};
window.exo.removeBroadcastListener = function (callback) {
    var newListeners = [];
    var listeners = window.exo.listeners;
    for (var _i = 0, listeners_2 = listeners; _i < listeners_2.length; _i++) {
        var listener = listeners_2[_i];
        if (listener == callback) {
            continue;
        }
        newListeners.push(listener);
    }
    window.exo.listeners = newListeners;
};
window.exo.currentUniqueIdentifierCounter = 0;
window.exo.generateUniqueIdentifier = function () {
    var uniqueIdentifierNumber = window.exo.currentUniqueIdentifierCounter;
    window.exo.currentUniqueIdentifierCounter += 1;
    return "exo:".concat(uniqueIdentifierNumber);
};
window.exo.performOperation = function (name) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var uniqueIdentifier = window.exo.generateUniqueIdentifier();
    return new Promise(function (resolve, reject) {
        var obj = {
            name: name,
            uniqueIdentifier: uniqueIdentifier,
            arguments: args
        };
        var cb = function (name, args) {
            if (name == "Exo.OperationComplete") {
                var operationCompleteArgs = args;
                if (operationCompleteArgs.uniqueIdentifier != uniqueIdentifier) {
                    return;
                }
                resolve({
                    typeName: operationCompleteArgs.typeName,
                    jsonData: operationCompleteArgs.jsonData
                });
                window.exo.removeBroadcastListener(cb);
            }
            else if (name == "Exo.OperationFailedWithError") {
                var failedWithErrorArgs = args;
                if (failedWithErrorArgs.uniqueIdentifier != uniqueIdentifier) {
                    return;
                }
                reject({
                    errorMessage: failedWithErrorArgs.errorMessage
                });
                window.exo.removeBroadcastListener(cb);
            }
        };
        window.exo.addBroadcastListener(cb);
        if (window.webkit == null) {
            window.exoAndroid.operation(JSON.stringify(obj));
        }
        else {
            window.webkit.messageHandlers.operation.postMessage(obj);
        }
    });
};
window.exo.inAppPurchase = {};
window.exo.inAppPurchase.list = function (identifiers) {
    return new Promise(function (resolve, reject) {
        window.exo.performOperation("Exo.InAppPurchase.List", identifiers).then(function (result) {
            var productList = JSON.parse(result.jsonData);
            resolve(productList);
        }, function (err) {
            reject(err);
        });
    });
};
window.exo.inAppPurchase.purchase = function (identifier) {
    return new Promise(function (resolve, reject) {
        window.exo.performOperation("Exo.InAppPurchase.Purchase", identifier).then(function (result) {
            var status = JSON.parse(result.jsonData);
            resolve(status);
        }, function (err) {
            reject(err);
        });
    });
};
window.exo.inAppPurchase.syncPurchases = function () {
    return new Promise(function (resolve, reject) {
        window.exo.performOperation("Exo.InAppPurchase.SyncPurchases").then(function () {
            resolve();
        }, function (err) {
            reject(err);
        });
    });
};
window.exo.videoPlayer = {};
window.exo.videoPlayer.play = function (url) {
    return new Promise(function (resolve, reject) {
        window.exo.performOperation("Exo.VideoPlayer.Play", url).then(function () {
            resolve();
        }, function (err) {
            reject(err);
        });
    });
};
